import { render, staticRenderFns } from "./goodsWeapp.vue?vue&type=template&id=eeadb578&scoped=true"
import script from "./goodsWeapp.vue?vue&type=script&lang=js"
export * from "./goodsWeapp.vue?vue&type=script&lang=js"
import style0 from "./goodsWeapp.vue?vue&type=style&index=0&id=eeadb578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeadb578",
  null
  
)

component.options.__file = "goodsWeapp.vue"
export default component.exports